import React from "react";
import SearchPage from "./pages/seach-page/SearchPage";

function App() {
  return (
    <>
      <SearchPage />
    </>
  );
}

export default App;
